import { render, staticRenderFns } from "./PrenotazioniCliente.vue?vue&type=template&id=51bb772d&"
import script from "./PrenotazioniCliente.vue?vue&type=script&lang=js&"
export * from "./PrenotazioniCliente.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports